import { cookieDecision } from "../../cookieconsent";
import { Cookie, CookieKeys } from "../../util/cookie";
import { loadOneTap } from "./one-tap/google-one-tap";
import { showSubscribeModal } from "../../components/subscribe-modal";
import { isFirstPageView } from "../../util/is-first-page-view";

const shouldSuppress = Cookie.get(CookieKeys.SuppressSlideUp) == "true";
const alreadySubscribed = Cookie.get(CookieKeys.EmailSubscribed) == "true";
const query = new URLSearchParams(window.location.search);
const forceShow = query.get("showsub") !== null;

cookieDecision.then(() => {
  const isGratisSalgsvurdering = window.location.pathname.includes(
    "gratis-salgsvurdering"
  );
  if (isGratisSalgsvurdering) {
    return;
  }

  if (forceShow) {
    return showSubscribeModal();
  }

  if (!shouldSuppress && !alreadySubscribed) {
    if (isFirstPageView()) {
      loadOneTap();
    } else {
      setTimeout(() => {
        showSubscribeModal();
      }, 16 * 1000);
    }
  }
});
